import physicalEntityForm from "@/core/services/forms/physicalEntityForm.js";
import { INIT_FORM } from "@/core/services/store/form.module.js";

export default {
  methods: {
    /**
     * Init entity form with empty fields and open entity form modal
     * @param {Object} fields
     * @return {void}
     */
    createPhysicalEntity(fields = null) {
      let form = JSON.parse(JSON.stringify(physicalEntityForm));
      if (fields) {
        for (const [key, value] of Object.entries(fields)) {
          form.fields[key] = value;
        }
      }
      this.$store.dispatch(INIT_FORM, form);
      if (this.$refs.physicalEntityFormModal) {
        this.$refs.physicalEntityFormModal.show();
      }
    },

    /**
     * Init entity form with edit mode and open entity form element
     * @param {Object} entity
     * @return {void}
     */
    editPhysicalEntity(entity) {
      let form = JSON.parse(JSON.stringify(physicalEntityForm));
      form.mode = "edit";
      form.path = form.path + "/" + entity.id;
      for (const [key, value] of Object.entries(entity)) {
        form.fields[key] = value;
      }
      form.fields._method = "PUT";
      form.helpers.notificationsSentBy =
        this.updateEntityBookingNotifications(entity);
      this.$store.dispatch(INIT_FORM, form);
      if (this.$refs.physicalEntityFormModal) {
        this.$refs.physicalEntityFormModal.show();
      }
    },

    /**
     * Update form booking notification field
     * @param {Object} entity
     * @return {string}
     */
    updateEntityBookingNotifications(entity) {
      return entity.bookingNotificationsEnabled == true ? "email" : "dont_send";
    },
  },
};
